import { z } from 'zod'

export const getFormConfig = (translations: (arg0: string) => any) => {
  const t = (key: string) => translations(key)

  const formConfig = {
    id: 'reset-password-email-form',
    fields: [
      {
        name: 'email',
        label: t('AUTHORIZATION.RESET_PASSWORD_EMAIL.EMAIL.LABEL'),
        placeholder: t('AUTHORIZATION.RESET_PASSWORD_EMAIL.EMAIL.PLACEHOLDER'),
        type: 'text',
        required: true,
        validation: z
          .string({
            required_error: t(
              'AUTHORIZATION.RESET_PASSWORD_EMAIL.EMAIL.VALIDATION.REQUIRED'
            )
          })
          .trim()
          .email({
            message: t(
              'AUTHORIZATION.RESET_PASSWORD_EMAIL.EMAIL.VALIDATION.INVALID'
            )
          })
      }
    ],
    onSubmit: (data: Record<string, any>) => {
      console.log('Form submitted:', data)
    }
  }
  return formConfig
}
